import * as constants from '../constants/ActionTypes';
import Page from '../../lib/page';

function updateLocale(nextLocale) {
  return {
    type: constants.LOCALE_CHANGED,
    payload: {
      nextLocale,
    },
  };
}

function updateLogout() {
  return {
    type: constants.LOGOUT,
  };
}

function updateLogin() {
  return {
    type: constants.LOGIN,
  };
}
export default function getLocale() {
  return (dispatch, getState) => {
    const {
      user: { locale, islogin },
    } = getState();
    if (Page.getLocale() !== locale) {
      dispatch(updateLocale(Page.getLocale()));
    }
    if (!Page.isLoggedIn() && (islogin || islogin === '') && !Page.getLogoutEmailRefId()) {
      // Hack way to checking init value for the user status at beginning
      dispatch(updateLogout());
    }
    if (Page.isLoggedIn()) {
      dispatch(updateLogin());
    }
  };
}
